<div class="mb-2">
    <p-button class="send-invitation-button" (click)="sendInvite()" [disabled]="selectedRows == undefined || selectedRows.length < 1">Send Invitation</p-button>
</div>
